(function () {
    'use strict';

    /*
     * BR semantic adapter. It adds stable Signal identities to confirmed
     * Dawn-derived controls without collecting their text or values.
     * Load before signal-storefront.js on an unpublished theme only.
     */
    const VERSION = 'br-dawn-2026-07';
    const mappings = [
        ['#cart-icon-bubble', 'header.cart', 'header', 'open_cart', false],
        ["[data-type='add-to-cart-form']", 'product.form', 'product_form', 'submit', false],
        ['variant-selects .product-form__input', 'product.variant_selector', 'product_form', 'select_variant', false],
        ['.product-form__quantity .quantity', 'product.quantity', 'product_form', 'change_quantity', false],
        ['.product-form__submit', 'product.add_to_cart', 'product_form', 'add_to_cart', true],
        ['#CartDrawer-Checkout', 'cart.checkout', 'cart_drawer', 'checkout', true]
    ];

    function announcePrivacyApi() {
        if (window.Shopify && window.Shopify.customerPrivacy) {
            document.dispatchEvent(new CustomEvent('shopifyCustomerPrivacyApiLoaded'));
        }
    }

    function loadPrivacyApi() {
        if (window.Shopify && window.Shopify.customerPrivacy) {
            announcePrivacyApi();
            return;
        }
        if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
        window.Shopify.loadFeatures([
            { name: 'consent-tracking-api', version: '0.1' }
        ], function (error) {
            if (!error) announcePrivacyApi();
        });
    }

    function annotate(root) {
        mappings.forEach(function (mapping) {
            const nodes = (root || document).querySelectorAll(mapping[0]);
            nodes.forEach(function (node) {
                node.dataset.signalComponent = mapping[1];
                node.dataset.signalRegion = mapping[2];
                node.dataset.signalAction = mapping[3];
                node.dataset.signalAdapterVersion = VERSION;
                if (mapping[4]) node.dataset.signalDeadcheck = 'true';
            });
        });
    }

    annotate(document);
    loadPrivacyApi();
    new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) {
                    if (node.matches && mappings.some(function (mapping) { return node.matches(mapping[0]); })) {
                        annotate(node.parentElement || document);
                    } else if (node.querySelectorAll) {
                        annotate(node);
                    }
                }
            });
        });
    }).observe(document.documentElement, { childList: true, subtree: true });
})();
